/**
 * Match the first number, or number-number (with optional whitespace around the dash)
 */
export const formatServingsText = (servings?: string): string => {
	if (!servings) {
		return '';
	}

	const match = servings?.match(/\d+(\s*-\s*\d+)?/);
	return !!match ? match[0] : '';
};
